import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Redirect, Route } from 'react-router-dom';

import Loader from '../layouts/admin/Loader';
import { authActions } from '../redux/actions/auth';

const AuthRoute = ({ currentUser, getCurrentUser, permission, component: Component, ...rest }) => {
    // Make initial request for logged-in user
    useEffect(() => getCurrentUser(), [getCurrentUser]);

    return currentUser === null ? (
        <Loader />
    ) : hasPermission() ? (
        <Route {...rest} render={matchProps => <Component {...matchProps} />} />
    ) : (
        <Redirect to={{ pathname: '/403' }} />
    );

    function hasPermission() {
        return undefined !== permission ? currentUser.permissions.includes(permission) : true;
    }
};

const mapStateToProps = state => {
    return {
        currentUser: state.auth.currentUser,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        getCurrentUser: () => {
            dispatch(authActions.getCurrentUser());
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(AuthRoute);
